// extracted by mini-css-extract-plugin
export default {"button":"button__ad6MG"};